import React from 'react';
import { CHECK_STATUS_MAP } from '../../data';
import './index.less';

const CheckStatus = (props) => {
  return (
    <div
      className={
        'resource-manage-checkstatus' + (props.checkStatus === 2 ? ' success' : props.checkStatus === 3 ? ' red' : '')
      }
    >
      {CHECK_STATUS_MAP[props.checkStatus]}
    </div>
  );
};

export default CheckStatus;
